import GazableButton from "components/GazableButton/GazableButton";
import gazableButtons from "constants/gazableButtons";
import { styles } from "./styles";
import { Link } from "react-router-dom";
import { routes } from "routes";
import backgroundImage from "../../static/landingPage.jpg";

const Home = () => {
  return (
    <div
      style={{
        ...styles.welcomeScreen,
        background: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${backgroundImage})`,
        backgroundPosition: "center top",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <h1>Tobii Dynavox Tower Defense</h1>
      <div style={styles.welcomeScreenActions}>
        <Link to={routes.playground}>
          <GazableButton
            type={gazableButtons.squareButton}
            content="Start"
          ></GazableButton>
        </Link>
      </div>
    </div>
  );
};

export default Home;
